export const RouterPath = Object.freeze({
    NOT_FOUND: 'not-found',
    VERIFY_CAPTCHA: 'verify-captcha',
    CHAT_SUPPORT: 'chat-support',
    VENDOR: 'product-support',
});
